declare global {
  interface Window {
    env: {
      ADMIN_SHELL_URL: string
      LAUNCH_DARKLY_CLIENT_ID: string
      CARROT_BACKEND_URL: string
      CARROT_BACKEND_ADMIN_URL: string
      CARROT_FRONTEND_URL: string
      SENTRY_URL: string
      LOGIN_URL: string
      HEAP_ENV_ID: string
    }
  }
}
const Settings = {
  CARROT_BACKEND_URL: window.env?.CARROT_BACKEND_URL,
  CARROT_BACKEND_ADMIN_URL: window.env?.CARROT_BACKEND_ADMIN_URL,
  CARROT_FRONTEND_URL: window.env?.CARROT_FRONTEND_URL,
  SENTRY_URL: window.env?.SENTRY_URL,
  LOGIN_URL: window.env?.LOGIN_URL,
  LAUNCH_DARKLY_CLIENT_ID: window.env?.LAUNCH_DARKLY_CLIENT_ID,
  ADMIN_SHELL_URL: window.env?.ADMIN_SHELL_URL,
  HEAP_ENV_ID: window.env?.HEAP_ENV_ID
}

export default Settings
